import { useCallback, useEffect, useState } from "react";
import * as api from "../../api";
import Dialogo from "./Dialogo";

const hora = iso => new Date(iso).toLocaleString("es-ES", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });

// El hilo de un encargo: comentarios cortos entre quien lo manda y quien lo recibe. Solo ellos lo ven;
// cada comentario avisa a la otra persona.
export default function HiloEncargo({ encargoId, titulo, onCerrar, onComentado }) {
  const [datos, setDatos] = useState(null);
  const [error, setError] = useState("");
  const [texto, setTexto] = useState("");
  const [enviando, setEnviando] = useState(false);

  const cargar = useCallback(() => api.getMensajesEncargo(encargoId)
    .then(d => { setDatos(d); setError(""); })
    .catch(e => setError(e?.message || "No se ha podido cargar el hilo")), [encargoId]);
  useEffect(() => { cargar(); }, [cargar]);

  const enviar = async e => {
    e.preventDefault();
    if (!texto.trim()) return;
    setEnviando(true);
    try {
      await api.enviarMensajeEncargo(encargoId, texto.trim());
      setTexto(""); await cargar(); onComentado?.();
    } catch (err) { setError(err?.message || "No se ha podido enviar el comentario"); }
    setEnviando(false);
  };

  return (
    <Dialogo titulo="Conversación de la tarea" onCerrar={onCerrar}>
      <p className="mt-nopuedo-t">{datos?.encargo?.titulo || titulo}</p>
      <div className="mt-hilo">
        {datos && !datos.mensajes.length && <p className="mt-sel-nota">Aún no hay comentarios.</p>}
        {(datos?.mensajes || []).map(m => (
          <div key={m.id} className={"mt-msg" + (m.mio ? " yo" : "")}>
            <small>{m.mio ? "Tú" : m.autor.nombre} · {hora(m.creado_at)}</small>
            {m.texto}
          </div>
        ))}
      </div>
      {/* Solo el ultimo comentario de la otra persona se anuncia: con aria-live en toda la lista se releian todos */}
      <span className="sr-only" role="status">
        {(() => { const u = [...(datos?.mensajes || [])].reverse().find(m => !m.mio); return u ? `${u.autor.nombre}: ${u.texto}` : ""; })()}
      </span>
      {error && <div className="mt-plan-aviso" role="alert"><span>{error}</span></div>}
      <form className="mt-form" onSubmit={enviar} noValidate>
        <label className="mt-lb" htmlFor="mt-coment">Comentario</label>
        <textarea id="mt-coment" className="mt-inp" rows={2} maxLength={2000} placeholder="Escribe un comentario corto…"
          value={texto} onChange={e => setTexto(e.target.value)} />
        <p className="mt-sel-nota">Solo lo ven quien la mandó y quien la recibe.</p>
        <div className="mt-dlg-pie"><button type="submit" className="mt-b p btn" disabled={enviando || !texto.trim()}>Enviar</button></div>
      </form>
    </Dialogo>
  );
}
